import { Button, Input, message } from "antd";
import { useState, useEffect } from "react";
import closeVisit from "./../../../../assets/images/close-visit.svg";
import loginBanner from "./../../../../assets/images/aa-banner.webp";
import scBanner from "./../../../../assets/images/sc-banner.webp";
import secureIcon from "./../../../../assets/images/secure.svg";
import tatvaPracticeLogo from "./../../../../assets/images/tatva-practice-logo.svg";
import success from "./../../../../assets/images/success.svg";
import OtpInput from "react-otp-input";
// MSG91 OTP is used instead of service calls
import call from "./../../../../assets/images/call.svg";
import arrow from "./../../../../assets/images/shaded-arrow.svg";
import edit from "./../../../../assets/images/edit-dark.svg";
import { setLocalStorage } from "../../../../utils/localStorage";
import { useLocation } from "react-router-dom";
import { JWT_TOKEN, MOBILE_NUMBER } from "../../utils/constants";
import { trackEvent } from "../../../../utils/helper";
import { getDecodedSCToken } from "../../symptomCollectorHelper";
import { teardownMsg91, MSG91_CONFIG, MSG91_SCRIPT_ID } from "../../../../utils/msg91Cleanup";
import dayjs from "dayjs";
import HeaderAppointment from "../../../appointmentAgent/components/headerAppointment/HeaderAppointment";

const LoginFullPage = ({
  phoneNumber,
  setPhoneNumber,
  isSCLoggedIn,
  setIsSCLoggedIn,
  agentDetails,
  setSelectedLanguage,
}: any) => {
  const location = useLocation();
  const jwtToken = new URLSearchParams(location.search).get(JWT_TOKEN) || "";
  const decodedToken: any = getDecodedSCToken(jwtToken);
  const {
    um_id,
    patient_unique_id,
    patient_name,
    patient_contact_no,
    doctor_name,
    hm_id,
    pam_id,
    dp_name,
    dp_id,
  } = decodedToken?.user || {};

  const [isOtpSent, setIsOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [count, setCount] = useState(20);
  const [isOtpIncorrect, setIsOtpIncorrect] = useState(false);
  const [isValidating, setIsValidating] = useState(false);
  const [isOtpLimitExceeded, setIsOtpLimitExceeded] = useState(false);
  const [isContinueDisabled, setIsContinueDisabled] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");
  const [isResending, setIsResending] = useState(false);

  const moengageData = {
    "Login Mobile No": phoneNumber,
    "Clinic Id": decodedToken?.user?.hm_id,
    "Clinic Name": decodedToken?.user?.hospital_name,
    "Time Stamp": dayjs().format("YYYY-MM-DD HH:mm:ss"),
  };

  // Load script on mount, teardown on unmount only
  useEffect(() => {
    const existingScript = document.getElementById(MSG91_SCRIPT_ID);
    if (!existingScript) {
      const script = document.createElement("script");
      script.id = MSG91_SCRIPT_ID;
      script.src =
        "https://control.msg91.com/app/assets/otp-provider/otp-provider.js";
      script.async = true;
      script.onload = () => {
        if ((window as any).initSendOTP) {
          (window as any).initSendOTP(MSG91_CONFIG);
        }
      };
      document.body.appendChild(script);
    } else if ((window as any).initSendOTP) {
      (window as any).initSendOTP(MSG91_CONFIG);
    }

    return () => {
      teardownMsg91();
    };
  }, []);

  // Re-init captcha when switching back to phone input
  useEffect(() => {
    const captchaEl = document.getElementById("captcha-id");
    if (!isOtpSent && captchaEl && (window as any).initSendOTP) {
      captchaEl.innerHTML = "";
      setTimeout(() => (window as any).initSendOTP(MSG91_CONFIG), 200);
    }
  }, [isOtpSent]);


  useEffect(() => {
    if (otp?.length === 6 && !isValidating) {
      handleVerifyOtp();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [otp]);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (isOtpSent && count > 0) {
      timer = setInterval(() => {
        setCount((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [isOtpSent, count]);

  // Function to start/reset the countdown timer
  const startTimer = () => {
    setCount(30);
  };

  const handleVerifyOtp = () => {
    if (!otp || otp.length < 6) {
      setIsOtpIncorrect(true);
      return;
    }

    trackEvent(pam_id ? "SC_OTP_Submit" : "AA_OTP_Submit", moengageData);
    setIsValidating(true);
    setIsOtpIncorrect(false);

    if ((window as any).verifyOtp) {
      (window as any).verifyOtp(
        otp,
        async (data: any) => {
          const { message: otpMessage } = data;

          // Check if the message is "Invalid OTP"
          if (otpMessage === "Invalid OTP") {
            setIsOtpIncorrect(true);
            setIsValidating(false);
            const moengageDataForFailedEvent = {
              appointment_id: pam_id,
              hospital_id: hm_id,
              doctor_name: doctor_name,
              doctor_id: um_id,
              patient_id: patient_unique_id,
              patient_name: patient_name,
              patient_mobile_number: patient_contact_no,
              doctor_speciality: dp_name,
              dp_id: dp_id,
              timestamp: dayjs().format("YYYY-MM-DD HH:mm:ss"),
            };
            trackEvent(
              pam_id ? "SC_Patient_OTP_Failed" : "AA_Patient_OTP_Failed",
              moengageDataForFailedEvent
            );
            return;
          }

          try {
            // After successful OTP verification, proceed with login
            setIsOtpIncorrect(false);
            setLocalStorage(JWT_TOKEN, jwtToken);
            setLocalStorage(MOBILE_NUMBER, phoneNumber);
            setIsSCLoggedIn(true);
          } catch (error) {
            console.error("Error during OTP verification:", error);
            setIsOtpIncorrect(true);
            const moengageDataForFailedEvent = {
              appointment_id: pam_id,
              hospital_id: hm_id,
              doctor_name: doctor_name,
              doctor_id: um_id,
              patient_id: patient_unique_id,
              patient_name: patient_name,
              patient_mobile_number: patient_contact_no,
              doctor_speciality: dp_name,
              dp_id: dp_id,
              timestamp: dayjs().format("YYYY-MM-DD HH:mm:ss"),
            };
            trackEvent(
              pam_id ? "SC_Patient_OTP_Failed" : "AA_Patient_OTP_Failed",
              moengageDataForFailedEvent
            );
          } finally {
            setIsValidating(false);
          }
        },
        (error: any) => {
          console.error("Error verifying OTP:", error);
          setIsOtpIncorrect(true);
          setIsValidating(false);
          const moengageDataForFailedEvent = {
            appointment_id: pam_id,
            hospital_id: hm_id,
            doctor_name: doctor_name,
            doctor_id: um_id,
            patient_id: patient_unique_id,
            patient_name: patient_name,
            patient_mobile_number: patient_contact_no,
            doctor_speciality: dp_name,
            dp_id: dp_id,
            timestamp: dayjs().format("YYYY-MM-DD HH:mm:ss"),
          };
          trackEvent(
            pam_id ? "SC_Patient_OTP_Failed" : "AA_Patient_OTP_Failed",
            moengageDataForFailedEvent
          );
        }
      );
    } else {
      console.error("verifyOtp method not found!");
      setIsOtpIncorrect(true);
      setIsValidating(false);
    }
  };

  const handleSubmit = () => {
    if (!phoneNumber || phoneNumber.length < 10) {
      setErrorMsg("Please enter a valid mobile number.");
      return;
    }

    // Check for Captcha Verification
    if ((window as any).isCaptchaVerified && !(window as any).isCaptchaVerified()) {
      setErrorMsg("Captcha verification is required. Please check the box to proceed.");
      return;
    }

    // Clear any previous error messages
    setErrorMsg("");

    trackEvent(
      pam_id ? "SC_MobileNo_Given" : "AA_MobileNo_Given",
      moengageData
    );

    // Use MSG91 sendOtp method
    if ((window as any).sendOtp) {
      (window as any).sendOtp(
        `91${phoneNumber}`,
        (data: any) => {
          setIsOtpSent(true);
          setCount(30);
          setErrorMsg(""); // Clear error message on success
          trackEvent(pam_id ? "SC_OTP_Success" : "AA_OTP_Success", moengageData);
          resendOTPToastMsg("Verification code has been sent. Please check your SMS.", true);
        },
        (error: any) => {
          console.error("Error sending OTP:", error);
          trackEvent(
            pam_id ? "SC_OTP_Failed" : "AA_OTP_Failed",
            moengageData
          );
          resendOTPToastMsg("Failed to send OTP. Please try again.", false);
        }
      );
    } else {
      console.error("sendOtp method not found!");
      resendOTPToastMsg("OTP service is unavailable. Please try again.", false);
    }
  };

  const handleOtpChange = (value: string) => {
    setOtp(value);
    setIsOtpIncorrect(false);
  };

  const otpResendHandler = () => {
    if (count > 0 || isOtpLimitExceeded || isResending) {
      return;
    }

    // Check if retryOtp method is available
    if (!(window as any).retryOtp) {
      console.error("retryOtp method not found!");
      setErrorMsg("Retry service is unavailable. Please try again later.");
      return;
    }

    setIsResending(true); // Show loader
    setErrorMsg(""); // Clear previous errors

    // Use MSG91 retryOtp method for resending
    (window as any).retryOtp(
      "11", // Retry type code (11 is standard for MSG91)
      (data: any) => {
        setIsOtpSent(true);
        setIsOtpLimitExceeded(false);
        setErrorMsg(""); // Clear error message
        startTimer(); // Restart the countdown timer
        setIsResending(false); // Hide loader
        resendOTPToastMsg("OTP has been resent. Please check your SMS.", true);
        
        // Track Moengage event
        trackEvent(pam_id ? "SC_OTP_Resend" : "AA_OTP_Resend", moengageData);
      },
      (error: any) => {
        console.error("Error retrying OTP:", error);
        setIsResending(false); // Hide loader

        // Check if it's a limit exceeded error
        if (error?.message?.includes("limit") || error?.message?.includes("maxed")) {
          setErrorMsg("Your OTP limit has been exceeded. Please try again later");
          setIsOtpLimitExceeded(true);
          resendOTPToastMsg(
            "Your OTP limit has been exceeded. Please try again later",
            false
          );
        } else {
          setErrorMsg("Failed to resend OTP. Please try again.");
          resendOTPToastMsg("Failed to resend OTP. Please try again.", false);
        }
        
        // Track Moengage error event
        trackEvent(
          pam_id ? "SC_OTP_Error" : "AA_OTP_Error",
          moengageData
        );
      }
    );
  };

  const resendOTPToastMsg = (textMsg: string, isSucess: boolean = false) => {
    const uniqueKey = `OTP_SENT_${Date.now()}`;
    message.open({
      key: uniqueKey,
      content: (
        <div className="flex items-center justify-center bg-[#171725E5]">
          {isSucess && <img src={success} className="me-3" alt="success" />}
          <div className="text-white mr-2">{textMsg}</div>
          <img
            src={closeVisit}
            alt="closeVisit"
            onClick={() => message.destroy(uniqueKey)}
            style={{ cursor: "pointer" }}
          />
        </div>
      ),
      duration: 5,
    });
  };

  const phoneNumberHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    if (/^\d*$/.test(input)) {
      setPhoneNumber(input);
      setIsContinueDisabled(input.length !== 10);
      setErrorMsg(""); // Clear error message when user types
    }
  };

  return (
    <div>
      <HeaderAppointment
        agentDetails={agentDetails}
        setSelectedLanguage={setSelectedLanguage}
        phoneNumber={phoneNumber}
        isSCLoggedIn={isSCLoggedIn}
      />

      <img
        src={pam_id ? scBanner : loginBanner}
        alt="login-banner"
        className="bg-cover bg-center bg-no-repeat bg-fixed w-full p-4 pt-8"
      />

      <div className="flex flex-col p-4">
        <div className="flex justify-between items-center mb-6"></div>
        {!isOtpSent ? (
          <div>
            <p className="text-gray-600 mb-2">Enter your mobile number</p>
            <div className="relative pb-2">
              <Input
                placeholder="Enter your phone number"
                prefix={
                  <div className="mt-[1px] flex items-center gap-x-2">
                    <img src={call} alt="user" className="p-2" />
                    {" +91 "}
                  </div>
                }
                disabled={pam_id && phoneNumber}
                // suffix={
                //   <button
                //     onClick={handleSubmit}
                //     disabled={isContinueDisabled}
                //     className={`p-2 rounded-full transition-opacity duration-200 ${
                //       isContinueDisabled
                //         ? "opacity-50 cursor-not-allowed"
                //         : "cursor-pointer"
                //     }`}
                //   >
                //     <img
                //       src={arrow}
                //       alt="submit"
                //       style={{ height: 24, width: 24 }}
                //     />
                //   </button>
                // }
                onChange={phoneNumberHandler}
                value={phoneNumber}
                name="phoneNumber"
                inputMode="numeric"
                maxLength={10}
                autoFocus={true}
              />
            </div>
            <div id="captcha-id"></div>
            {errorMsg && (
              <div className="text-xs text-left leading-[18px] text-[#5A6774] mt-2">
                <div className="text-red-400">{errorMsg}</div>
              </div>
            )}
            <div className="text-xs pt-2">
              By continuing, you agree to{" "}
              <span className="font-semibold underline">T&C</span> &{" "}
              <span className="font-semibold underline">Privacy policy</span>
            </div>
          </div>
        ) : (
          <div className="flex flex-col items-start gap-y-3">
            <div className="flex items-center gap-2">
              <span className="text-sm">
                Enter OTP sent to{" "}
                <span className="underline">+91-{phoneNumber}</span>
              </span>
              <img
                src={edit}
                alt="edit"
                className="w-4 h-4 cursor-pointer"
                onClick={() => {
                  setIsOtpSent(false);
                  setOtp(""); // Clear OTP input
                  setIsOtpIncorrect(false); // Clear OTP error
                  setErrorMsg(""); // Clear any error messages
                  setCount(0); // Reset countdown
                  setIsOtpLimitExceeded(false); // Reset limit exceeded flag
                }}
              />
            </div>
            <OtpInput
              value={otp}
              onChange={handleOtpChange}
              numInputs={6}
              shouldAutoFocus={true}
              containerStyle={`w-full flex !justify-between`}
              inputStyle={`!h-[42px] !w-[42px] border border-[#DCE4E8] rounded-[8px] bg-[#FFFFFF] outline-none ${
                isOtpIncorrect
                  ? "border-red-500"
                  : "focus:border-primary hover:border-primary"
              }`}
              renderInput={(props) => (
                <input
                  {...props}
                  disabled={isValidating}
                  type="number"
                  inputMode="numeric"
                />
              )}
            />
            {isOtpIncorrect && (
              <span className="text-red-400 text-xs">
                Invalid OTP. Try Again
              </span>
            )}
            {count > 0 ? (
              <div className="text-xs text-left leading-[18px] text-[#5A6774] mt-2">
                Didn't receive OTP? Resend code in {count} sec
              </div>
            ) : isOtpLimitExceeded || errorMsg ? (
              <div className="text-xs text-left leading-[18px] text-[#5A6774] mt-2">
                <div className="text-red-400">
                  {isOtpLimitExceeded
                    ? "Your OTP limit has been exceeded. Please try again later"
                    : errorMsg}
                </div>
              </div>
            ) : (
              <div className="text-xs text-left leading-[18px] text-[#5A6774] flex gap-x-2 mt-2">
                <div>Didn't receive OTP?</div>
                <u
                  className={`text-[#4B4AD5] font-semibold ${
                    isResending
                      ? "cursor-not-allowed opacity-50"
                      : "cursor-pointer"
                  }`}
                  onClick={otpResendHandler}
                >
                  {isResending ? "Resending..." : "Resend OTP"}
                </u>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Continue Button */}
      <div className="fixed bottom-14 left-0 right-0 px-4 max-w-[450px] m-auto">
        <Button
          className={`flex justify-center overflow-hidden gap-2 self-stretch px-6 py-4 text-white bg-indigo-600 whitespace-nowrap rounded-2xl border border-indigo-600 border-solid w-full h-[50px] text-lg font-medium`}
          onClick={() => {
            if (!isOtpSent) {
              handleSubmit();
            }
          }}
          // disabled={isContinueDisabled || isValidating}
        >
          {isOtpSent
            ? isValidating
              ? "Submitting OTP..."
              : "Submit OTP"
            : "Continue"}
        </Button>
      </div>

      {/* Footer */}
      <div className="fixed bottom-6 left-0 right-0 flex items-center justify-center gap-2 mix-blend-luminosity">
        <div className="flex gap-2 justify-center opacity-40 mix-blend-luminosity">
          <img src={secureIcon} alt="secure-icon" />
          <div className="text-xs text-[#454551] flex gap-1">
            Powered by <img src={tatvaPracticeLogo} alt="tatvaPracticeLogo" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginFullPage;
